import api from "@/lib/axios";

type AuthPayload = {
  name?: string;
  email: string;
  password: string;
};

type ResetPasswordPayload = {
  token: string;
  newPassword: string;
};

type ForgotPasswordPayload = {
  email: string;
};

type ChangePasswordPayload = {
  oldPassword: string;
  newPassword: string;
};

// Signup
export const signup = async (data: AuthPayload): Promise<void> => {
  await api.post("/auth/signup", data);
};

// Login
export const login = async (data: AuthPayload): Promise<void> => {
  await api.post("/auth/login", data);
};

// Logout
export const logout = async (): Promise<void> => {
  await api.post("/auth/logout");
};

/** Ends every session of the account, this one included, and its MCP sign-ins. */
export const logoutAll = async (): Promise<void> => {
  await api.post("/auth/logout-all");
};

export const getCurrentUser = async () => {
  const res = await api.get("/auth/me");
  return res.data;
};

export const requestPasswordReset = async (data: ForgotPasswordPayload): Promise<void> => {
  await api.post("/auth/forgot-password", data);
};

export const resetPassword = async (data: ResetPasswordPayload): Promise<void> => {
  await api.post("/auth/reset-password", data);
};

export const changePassword = async (data: ChangePasswordPayload): Promise<void> => {
  await api.patch("/auth/change-password", data);
};

export const verifyEmail = async (token: string): Promise<void> => {
  await api.post("/auth/verify-email", { token });
};
